<template>
    <SafetyVideos></SafetyVideos>
</template>

<script>
import { defineAsyncComponent } from "vue";

const GuestLayout = defineAsyncComponent(() =>
    import("../../Layouts/GuestLayout.vue")
);
const SafetyVideos = defineAsyncComponent(() =>
    import("../../components/Safety/SafetyVideos.vue")
);

export default {
    name: "SafetyVideosUnauth", //The name you are in should not equal the name of the component you are importing.
    components: { SafetyVideos, GuestLayout },
    layout: [GuestLayout],
};
</script>
